/**
 * The footer's menus. Entries carry a stable `id` rather than a label: labels are translated by
 * the caller (footerStrings.ts) and reach the dropdown as a serializable map keyed by these ids.
 */

/** A menu entry that navigates, or one that runs an action (e.g. the cookie drawer). */
export type FooterMenuItem =
    | { id: string; to: string }
    | { id: string; onSelect: () => void };

export type FooterMenu = {
    items: FooterMenuItem[];
};

/** A menu's translated copy: the trigger's label and each entry's, by entry id. */
export type FooterMenuLabels = {
    menu: string;
    items: Record<string, string>;
};

export const RESOURCES_MENU: FooterMenu = {
    items: [
        { id: 'faqs', to: '/faqs' },
        { id: 'glossary', to: '/glossary' },
        { id: 'changelog', to: '/changelog' },
        // Temporary home: this content moves onto the About page when that design lands.
        { id: 'partnersAndVendors', to: '/partners-and-vendors' },
    ],
};

export const LEGAL_MENU: FooterMenu = {
    items: [
        { id: 'privacyPolicy', to: '/privacy-policy' },
        { id: 'termsOfUse', to: '/terms-of-use' },
        { id: 'cookieSettings', onSelect: () => window.Osano?.cm?.showDrawer?.() },
    ],
};

export const CONTACT_LINK = { to: '/contact-us' };
